import { PayFac } from '../gql-types.generated';

// PTT and NUVEI are both NMI gateway accounts: the same Collect.js card and bank fields, on different hosts.
// Compared as strings so the portal builds against a schema that does not list NUVEI yet.
const nmiPayFacs: string[] = [PayFac.Ptt, 'NUVEI'];

export const isNmiPayFac = (payFac?: PayFac | string | null): boolean => !!payFac && nmiPayFacs.includes(payFac);
